export enum ECreatorFormStatus {
	PENDING="PENDING",
	ACCEPTED="ACCEPTED",
	REJECTED="REJECTED"
}
